import React from 'react'

import defaultOptions from './utils/defaultOptions'

// eslint-disable-next-line import/prefer-default-export
export const themeOptions = React.createContext(defaultOptions)
